export enum EnumIndexType {
  /**
   * 整型
   */
  Integer = 0,


   /**
    * 字符串
    */
  String = 1

}
